import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ClearIcon from "@mui/icons-material/Clear";

export default function DynamicTab({
  index,
  tabData,
  nameKey,
  isActive,
  handleTabChange,
  deleteTabModalOpen,
  setDeleteTabModalOpen,
  setIndexToDelete,
}) {
  return (
    <Box
      sx={{
        ...isActive && { color: "primary.60", borderBottom: "2px solid" },
        marginRight: "12px",
        minHeight: "24px",
        minWidth: "fit-content",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "12px 4px 4px 4px",
        "&:hover": { cursor: "pointer" }
      }}
      onClick={() => {
        if (!deleteTabModalOpen) {
          handleTabChange(index);
        }
      }}
    >
      <Typography variant="subhead1" color="black_solid.80">
        {tabData[nameKey]}
      </Typography>
      {!tabData.disableDelete &&
        <ClearIcon
          sx={{
            marginLeft: "5px",
            fontSize: "14px",
            color: "black_solid.80",
            "&:hover": { cursor: "pointer", fontSize: "16px" }
          }}
          onClick={(e) => {
            e.stopPropagation();
            setIndexToDelete(index);
            setDeleteTabModalOpen(true);
          }}
        />
      }
    </Box>
  );
}

DynamicTab.propTypes = {
  index: PropTypes.number.isRequired,
  tabData: PropTypes.object.isRequired,
  nameKey: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  deleteTabModalOpen: PropTypes.bool.isRequired,
  setDeleteTabModalOpen: PropTypes.func.isRequired,
  setIndexToDelete: PropTypes.func.isRequired,
};